import { Injectable } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import {
    EsportTrackingValues,
    NOT_APPLICABLE,
    TrackingService,
    VideoStreamTrackingStatus,
    trackingConstants,
} from '@frontend/sports/tracking/feature';
import { UserService } from '@frontend/sports/user/feature';

import { TrackVideoStreaming } from './video-tracking.model';

@Injectable({ providedIn: 'root' })
export class VideoStreamTrackingService {
    constructor(
        private trackingService: TrackingService,
        private userService: UserService,
    ) {}

    track(event: EventModel, trackingSource: string, isVideoAvailable: boolean): void {
        const trackingData: TrackVideoStreaming = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: VideoStreamTrackingStatus.VideoStreaming,
            [trackingConstants.COMPONENT_LABEL_EVENT]: event.stream ? event.stream.provider : '',
            [trackingConstants.COMPONENT_ACTION_EVENT]: VideoStreamTrackingStatus.VideoInitiated,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: event.name,
            [trackingConstants.COMPONENT_POSITION_EVENT]: trackingSource,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: !this.userService.isAuthenticated
                ? VideoStreamTrackingStatus.UserNotLoggedIn
                : !isVideoAvailable
                  ? VideoStreamTrackingStatus.VideoContent
                  : VideoStreamTrackingStatus.VideoStarted,
            [trackingConstants.COMPONENT_URL_CLICKED]: VideoStreamTrackingStatus.NotApplicable,
            [trackingConstants.VIDEO_PROVIDER_EVENT_ID]: event.stream ? event.stream.id : '',
            [trackingConstants.VIDEO_INTERNAL_EVENT_ID]: event.id,
        };

        this.trackingService.track('Event.SelectVideo', trackingData);
    }

    trackVideoStreamButtonClick(eventName: string): void {
        this.trackingService.track(trackingConstants.EVENT_TRACKING, {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'scoreboard',
            [trackingConstants.COMPONENT_LABEL_EVENT]: EsportTrackingValues.Esports,
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: eventName,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: VideoStreamTrackingStatus.StreamingAvailableCta,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        });
    }
}
